import React from 'react'
import './OurSuccess.css';
import startup from '../images/png/imageremovebg.png';
import startup1 from '../images/png/imageremovebg2.png';
import startup2 from '../images/png/imageremovebg3.png';
import startup3 from '../images/png/imageremovebg4.png';
import startup4 from '../images/png/imageremovebg5.png';



const OurSuccess=()=> {
  return (
    <div>
        <div className='oursuccess'>
            <div className='success'>
                <h1>Our Success</h1>
                <p>journey of our success</p>                
            </div>
            <div className='golacard'>
                <div className='start'>
                    <div className='gola'>
                        <img src={startup} alt="err"/>
                    </div>
                    <div className='golacontent'>
                        <p>Back in 2019, FliqaIndia recognize<br/>as a startup with DPIT in Startup <br/> India.</p> 
                    </div>
                </div>
                <div className='start'>
                    <div className='gola'>
                        <img src={startup1} alt="err"/>
                    </div>
                    <div className='golacontent'>
                        <p>Back in 2019, FliqaIndia recognize<br/>as a startup with DPIT in Startup <br/> India.</p> 
                    </div>
                </div>
                <div className='start'>
                    <div className='gola'>
                        <img src={startup2} alt="err"/>
                    </div>
                    <div className='golacontent'>
                        <p>Back in 2019, FliqaIndia recognize<br/>as a startup with DPIT in Startup <br/> India.</p> 
                    </div>
                </div>
                <div className='start'>
                    <div className='gola'>
                        <img src={startup3} alt="err"/>
                    </div>
                    <div className='golacontent'>
                        <p>Back in 2019, FliqaIndia recognize<br/>as a startup with DPIT in Startup <br/> India.</p> 
                    </div>
                </div>
                <div className='start'>
                    <div className='gola'>
                        <img src={startup4} alt="err"/>
                    </div>
                    <div className='golacontent'>
                        <p>Back in 2019, FliqaIndia recognize<br/>as a startup with DPIT in Startup <br/> India.</p> 
                    </div>
                </div>
              
            </div>
            
        </div>
    </div>
  )
}
export {OurSuccess}
